import styled from 'styled-components';

export const StyledContainer = styled.div<{
  $isError?: boolean;
  $disabled?: boolean;
  $isChecked?: boolean;
  $isTaskBreakdownSupported: boolean;
}>`
  display: flex;
  align-items: center;
  max-width: ${({ $isTaskBreakdownSupported }) => ($isTaskBreakdownSupported ? '100%' : '50rem')};
  padding: 1rem 1.6rem;
  margin: 0.5rem 0;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.border.main};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  flex-wrap: wrap;

  ${({ $isChecked, $disabled, theme }) =>
    $disabled &&
    !$isChecked &&
    `
    background-color: ${theme.colors.grey[200]};
    border-color: #D4D8DF;
    opacity: 0.5;
  `}

  ${({ $isChecked, theme }) =>
    $isChecked &&
    `
      background-color: ${theme.colors.background.active};
      border-color: ${theme.colors.success.main};
      
    `}
    ${({ $isError }) =>
    $isError &&
    `
    background-color: rgba(235, 0, 55, 0.02);
    border-color: #EB0037;
    `}
`;

export const StyledInput = styled.input`
  appearance: none;
  margin-right: 1rem;
  width: 2rem;
  height: 2rem;
  border: 1px solid #d4d8df;
  border-radius: 50%;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:checked {
    border-color: ${({ theme }) => theme.colors.success.main};

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.success.main};
    }

    &[aria-invalid='true']::after {
      background-color: rgba(235, 0, 55, 0.02);
      border-color: #eb0037;
    }
  }
  &[aria-invalid='true'] {
    border-color: #eb0037;
  }
`;

export const StyledLabel = styled.label<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  line-height: 1.6rem;
`;

export const StyledErrorMessage = styled.span`
  margin-top: 0.6rem;
  font-size: 1.2rem;
  line-height: 1.6rem;
  color: #eb0037;
`;

export const StyledRadioSelectionWrapper = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;

export const StyledRadioInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;
